@if (is_mobile() || is_tablet()) {
<div class="flex justify-between items-center border-1 border-b px-3 py-2 primary-bg border-gray-300 w-full">
  <div class="text-xl text-white">Add Room & Guests</div>
  <button mat-icon-button (click)="matDialogRef.close()" class="items-center text-white" [tabIndex]="-1">
    <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
  </button>
</div>
}
<div class="font-Inter sticky top-0 nottablet:-m-[24px]">
  <div class="content">
    <div class="border-b border-[#E3EBF5]">
      <div class="flex justify-between items-center p-3 px-4 rounded-md">
        <span class="font-semibold text-md">Rooms</span>
        <div class="flex items-center gap-3">
          <i class="material-icons prevent-select rounded-md border border-gray-300 p-1 cursor-pointer active:border active:border-primaryColor hover:border-primaryColor"
            (click)="decrease('rooms')">remove</i>
          <span class="primary-text font-semibold">
            {{ roomData.rooms }}
          </span>
          <i class="material-icons prevent-select border border-gray-300 rounded-md p-1 cursor-pointer active:border active:border-primaryColor active:shadow-lg hover:border-primaryColor"
            (click)="increase('rooms')">add</i>
        </div>
      </div>
    </div>
    <div class="border-b border-[#E3EBF5]">
      <div class=" flex justify-between items-center p-3 px-4 rounded-md">
        <div class="flex flex-col">
          <span class="font-semibold text-md">Adults</span>
          <span class="text-sm text-gray-500">(18 Years & Above)</span>
        </div>
        <div>
          <div class="flex items-center gap-3">
            <i class="material-icons prevent-select rounded-md border border-gray-300 p-1 cursor-pointer active:border active:border-primaryColor hover:border-primaryColor"
              (click)="decrease('totaladult')">remove</i>
            <span class="primary-text font-semibold">
              {{ roomData.totaladult }}
            </span>
            <i class="material-icons prevent-select border border-gray-300 rounded-md p-1 cursor-pointer active:border active:border-primaryColor active:shadow-lg hover:border-primaryColor"
              (click)="increase('totaladult')">add</i>
          </div>
        </div>
      </div>
    </div>
    <div class="border-b border-[#E3EBF5]">
      <div class=" flex justify-between items-center p-3 px-4 rounded-md">
        <div class="flex flex-col">
          <span class="font-semibold text-md">Children</span>
          <span class="text-sm text-gray-500">(0-17 Years)</span>
        </div>
        <div>
          <div class="flex items-center gap-3">
            <i class="material-icons prevent-select rounded-md border border-gray-300 p-1 cursor-pointer active:border active:border-primaryColor hover:border-primaryColor"
              (click)="decrease('totalchild')">remove</i>
            <span class="primary-text font-semibold">
              {{ roomData.totalchild }}
            </span>
            <i class="material-icons prevent-select border border-gray-300 rounded-md p-1 cursor-pointer active:border active:border-primaryColor active:shadow-lg hover:border-primaryColor"
              (click)="increase('totalchild')">add</i>
          </div>
        </div>
      </div>
    </div>
    @if (roomData.totalchild > 0) {
    <div class="mt-4 px-4">
      <div class="text-sm font-medium mb-2 text-gray-500">Age of Children</div>
      @if (!is_mobile()) {
      <div class="grid grid-cols-3 gap-2 mb-2 max-h-40 overflow-y-scroll">
        @for (age of childAges; track age; let i = $index) {
        <div class="flex flex-col gap-1">
          <span class="text-sm font-medium">Child {{i+1}} </span>
          <select class="border border-primary-500 rounded-lg p-1 text-sm w-full" [(ngModel)]="age.id"
            (change)="updateChildYears(i)">
            @for (year of childYears; track year) {
            <option [value]="year">{{ year }} year</option>
            }
            <pre>{{ childYears | json }}</pre>
          </select>
        </div>
        }
      </div>
      }
      @if (is_mobile()) {
      <div class="flex flex-col mb-2 max-h-60 overflow-y-scroll">
        @for (age of childAges; track age; let i = $index) {
        <div class="flex justify-between mt-2">
          <span class="text-sm font-medium">Child {{i+1}} </span>
          <select class="border border-primary-500 rounded-lg py-2 text-sm w-30" [(ngModel)]="childAges[i].id"
            (change)="updateChildYears(i)">
            @for (year of childYears; track year) {
            <option [value]="year">{{ year }} year</option>
            }
          </select>
        </div>
        }
      </div>
      }
    </div>
    }
    <div class="flex items-end justify-end justify-items-end p-2 border-t border-gray-200 mobile:hidden">
      <div class="flex w-30 gap-2 mobile:hidden">
        <button mat-flat-button class="primary-bg rounded-xl white-text flex-grow h-[41px]" (click)="applySelection()">
          <span class="white-text">APPLY</span>
        </button>
      </div>
    </div>
    <div
      class="mobile:fixed mobile:border-t mobile:border-gray-200 mobile:bottom-0 mobile:w-full mobile:p-2 mobile:bg-white">
      <button class="primary-bg w-[50%] min-h-13 rounded-lg notmobile:hidden" (click)="applySelection()">
        <span class="white-text font-semibold text-lg">APPLY</span>
      </button>
    </div>
  </div>
</div>